import { network } from 'services/network';

import { QueryParams } from 'api/queries/clustersDataBySearchWord.query';

export const getCustomCluster = (params: QueryParams) => {
    return network
        .post('api/bo/getCustomCluster', {
            customerId: params.customerId,
            paFileMetaDataIds: params.idList,
            projectId: params.projectId,
            query: params.searchWord,
            clusterType: params.compare,
        })
        .then((response) => {
            return response.data;
        });
};
